export default __webpack_public_path__ + "static/media/bugsee.50a120ad.svg";